export const MerkleWL4 = [
  "0x6af2d1a67ea8421860bd7c5aaccffdbed1a71e4f",
  "0x6F10073D9154967B209F5c1cf578E42cd7A51b70",
  "0x7568da13df70012a38e359449dc30d1cde9f646c",
  "0xea35c92fc2b2d0eca27fae3e06f26a801a1ff469",
  "0xf438f8f008aff430ebb516b9ecbe285d91146c5a",
  "0x615d221552B136BC59BDCc5553802E36aff309d4"
]